import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=244e2672&scoped=true&"
import script from "./kpi.vue?vue&type=script&lang=js&"
export * from "./kpi.vue?vue&type=script&lang=js&"
import style0 from "./kpi.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./kpi.vue?vue&type=style&index=1&id=244e2672&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e2672",
  null
  
)

export default component.exports